export default import.meta.ROLLDOWN_FILE_URL_VuJlMrRhsck015XHJTM3ow